import { BuyToneDto, BuyToneDtoImpl } from '../../../../core/dto/buytone/buytonedto';
import { BuyToneComponentProps, BuyToneComponentHandler, BuyToneComponentState } from './buytonecomponent';
import { BuyToneCSSStyle } from './buytonecss';
import * as React from 'react';
import { ToneDetailsPopupComponent, ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { Strings } from '../../../../utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../confirmrequest/confirmrequestconfirmbuttoncss';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { MSISDNValidation } from '../../../toolkit/msisdnvalidation/msisdnvalidation';
import { SendOTPDto, SendOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { LoaderWrapperComponent } from '../loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import './buytone-style.css';
import { CheckboxWithTextComponent } from '../../../toolkit/checkboxwithtext/checkboxwithtextcomponent';
import { BuyToneCheckboxCSSStyleImpl } from './buytonecheckboxcss';
// import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class BuyToneViewImpl extends UIComponentViewImpl<BuyToneDto> {

    private contactNumber: MsisdnFloatingTextComponent;
    private loaderWrapperComponent: LoaderWrapperComponent;

    bindHandlers() {
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onClosePopup = this.onClosePopup.bind(this);
        this.onRequestOtpClick = this.onRequestOtpClick.bind(this);
        this.onSelected = this.onSelected.bind(this);
        this.routeToUpgradePack = this.routeToUpgradePack.bind(this);
    }

    draw(props: BuyToneComponentProps, state: BuyToneComponentState, cssStyle: BuyToneCSSStyle): JSX.Element | boolean {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                {
                    this.getWebView(props, state, cssStyle)
                }

                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context} />

            </div>
        );
    }


    getWebView(props: BuyToneComponentProps, state: BuyToneComponentState, cssStyle: BuyToneCSSStyle): JSX.Element {
        console.log("Upgrade pack name: ", props.context.getUserContext().getPackName());
        console.log("Settings pack details :", this.getContext().getConfigurationSettings().getProperty("CRBT_VIP_OFFER_CODE"));
        console.log("Settings pack details :", this.getContext().getConfigurationSettings().getProperty("CRBT_MONTHLY_OFFER_CODE"));
        console.log("Settings pack details :", this.getContext().getConfigurationSettings().getProperty("CRBT_DAILY_OFFER_CODE"));
        console.log("Settings pack details :", this.getContext().getConfigurationSettings().getProperty("CRBT_WEEKLY_OFFER_CODE"));



        return (
            <>
                <ToneDetailsPopupComponent onCloseClick={props.closePopup} headerTitle={props.toneOptionsType === ToneOptionsType.TONE ? props.context.getResources().getString(Strings.buytone) : props.context.getResources().getString(Strings.buy_playlist)} toneDto={props.toneDto} context={props.context} />

                <div id="buytone-main">

                    <div id="buytone-header-main">
                        <label id="buytone-header-price">
                            {this.getContext().getResources().getString(Strings.tune_charge)}
                        </label>
                        <label id="buytone-header-absolute-validity">
                            {this.getContext().getResources().getString(Strings.absolute_validity)}
                        </label>
                    </div>
                    <div id="buytone-header-value">
                        <label id="buytone-header-price-value">
                            {state.price}
                        </label>
                        <label id="buytone-header-absolute-validity-value">
                            {props.toneDto.getExpirydate()}
                        </label>
                    </div>

                    {
                        props.context.getUserContext().getIsLoggedIn() && (state.packName !== this.getContext().getConfigurationSettings().getProperty("CRBT_VIP_OFFER_CODE")) &&
                        <div id="buytone-unlimited-pack-div" style={{}}>

                            <CheckboxWithTextComponent onChange={this.onSelected} isChecked={state.isPackUpgradeSelected} style={new BuyToneCheckboxCSSStyleImpl(props.context)} title={state.isNewUser ? props.context.getResources().getString(Strings.free_unlimited_pack_upgrade) : props.context.getResources().getString(Strings.upgrade_free_tune_pack)} context={props.context} />

                        </div>}
                    {/* <div id="buytone-unlimited-pack-div" style={{ marginBottom: '20px' }}>

                        <CheckboxWithTextComponent onChange={this.onSelected} isChecked={state.isPackUpgradeSelected} style={new BuyToneCheckboxCSSStyleImpl(props.context)} title={"RingNote Combo (Unlimited Tunes & Note4U) ဝန်ဆောင်မှုရယူရန်"} context={props.context} />

                    </div> */}
                    {
                        !props.context.getUserContext().getIsLoggedIn() && state.isPrice && (state.packName !== this.getContext().getConfigurationSettings().getProperty("CRBT_VIP_OFFER_CODE")) &&
                        <div id="buytone-unlimited-pack-div" style={{}}>

                            <CheckboxWithTextComponent onChange={this.onSelected} isChecked={state.isPackUpgradeSelected} style={new BuyToneCheckboxCSSStyleImpl(props.context)} title={state.isNewUser ? props.context.getResources().getString(Strings.free_unlimited_pack_upgrade) : props.context.getResources().getString(Strings.upgrade_free_tune_pack)} context={props.context} />

                        </div>}


                </div>
                {
                    !state.isPrice && !props.context.getUserContext().getIsLoggedIn() &&
                    <div>
                        <div style={cssStyle.getMobileNumberCSSStyle()}>
                            <MsisdnFloatingTextComponent hint={props.context.getResources().getString(Strings.mobilenumberhint)} maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.contactNumber = item} id={"#mobilenumber"} value={""} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.entercontactnumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)} />
                        </div>

                    </div>
                }
                {
                    state.isPrice && !props.context.getUserContext().getIsLoggedIn() ?
                        <div style={cssStyle.getConfirmButtonCSSStyle()}>
                            <ButtonComponent onClick={this.onRequestOtpClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)} />
                        </div>
                        :
                        <div style={cssStyle.getConfirmButtonCSSStyle()}>
                            <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getUserContext().getIsLoggedIn() ? props.context.getResources().getString(Strings.confirm) : props.context.getResources().getString(Strings.verify)} />
                        </div>


                }
                <div style={cssStyle.getRowDivCSSStyle()}>
                    <div style={cssStyle.getTermsConditionCSSStyle()}>
                        <a style={cssStyle.getAnchorCSSStyle()} target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("TND")}>
                            {props.context.getResources().getString(Strings.terms_condition)}

                        </a>
                    </div>
                </div>

            </>
        );
    }


    // getMobileView(props: BuyToneComponentProps, state: BuyToneComponentState, cssStyle: BuyToneCSSStyle):JSX.Element
    // {
    //     return(
    //         <>
    //              <ToneDetailsPopupComponent onCloseClick={props.closePopup} headerTitle={props.toneOptionsType === ToneOptionsType.TONE ? props.context.getResources().getString(Strings.buytone) : props.context.getResources().getString(Strings.buy_playlist)} toneDto={props.toneDto} context={props.context}/>
    //            {/* <div style={cssStyle.getContentDivCSSStyle()}>
    //                 <label style={cssStyle.getContentLabel1CSSStyle()}>
    //                     {props.context.getResources().getString(Strings.get_your_loved_tune)}
    //                 </label>
    //                 <label style={cssStyle.getContentLabel2CSSStyle()}>
    //                     {props.context.getResources().getString(Strings.SDG_for_60_days)}
    //                 </label>
    //            </div>   
    //            <label style={cssStyle.getSubcriptionDivCSSStyle()}>
    //             {props.context.getResources().getString(Strings.Subscription_charges_of_2_SDG_for_30_days)}
    //            </label>  */}

    //                 <div style={{width:'100%',height:'50px',position:"relative",marginTop:'30px',paddingLeft:'25px',paddingRight:'25px'}}>

    //                         <div style={{width:'100%',height:'20px',lineHeight:'20px',fontSize:'10px',color:'#898989' }}>
    //                                  <label style={{width:'50%',height:'100%',lineHeight:'100%',textAlign:'left'}}>
    //                                      {this.getContext().getResources().getString(Strings.tune_charge)}
    //                                  </label>
    //                                  <label style={{width:'50%',height:'100%',lineHeight:'100%',textAlign:'right'}}>
    //                                      {this.getContext().getResources().getString(Strings.absolute_validity)}
    //                                  </label>
    //                          </div> 
    //                          <div style={{width:'100%',height:'20px',lineHeight:'20px',fontSize:'12px',color:'#33495F',fontWeight:900 }}>
    //                                  <label style={{width:'60%',height:'100%',lineHeight:'100%',textAlign:'left'}}>
    //                                      {state.price}
    //                                  </label>
    //                                  <label style={{width:'40%',height:'100%',lineHeight:'100%',textAlign:'right'}}>
    //                                      {props.toneDto.getExpirydate()}
    //                                  </label>
    //                          </div>
    //                </div>
    //                {
    //                   !state.isPrice && !props.context.getUserContext().getIsLoggedIn() &&
    //                   <div> 
    //                             <div style={cssStyle.getMobileNumberCSSStyle()}>
    //                             <MsisdnFloatingTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.contactNumber = item} id={"#mobilenumber"} value={""} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.entercontactnumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
    //                             </div>

    //                 </div>    
    //                }
    //                 {
    //                     state.isPrice && !props.context.getUserContext().getIsLoggedIn() ?

    //                   <div style={cssStyle.getConfirmButtonCSSStyle()}>
    //                       <ButtonComponent onClick={this.onRequestOtpClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
    //                 </div>
    //                     :
    //                   <div style={cssStyle.getConfirmButtonCSSStyle()}>
    //                       <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getUserContext().getIsLoggedIn() ? props.context.getResources().getString(Strings.confirm) : props.context.getResources().getString(Strings.verify)}/>
    //                 </div>



    //                 }
    //                  <div style={cssStyle.getRowDivCSSStyle()}>
    //                                 <div style={cssStyle.getTermsConditionCSSStyle()}>
    //                                 <a style={cssStyle.getAnchorCSSStyle()} target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("TND")}>
    //                                         {props.context.getResources().getString(Strings.terms_condition)}

    //                                     </a>
    //                                 </div>
    //                            </div> 

    //         </>
    //     );
    // }
    showLoader() {

        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true, <LoaderComponent context={this.getUIProps().context} />);
    }

    dismissLoader() {
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    onRequestOtpClick() {
        (this.getUIComponentHandler() as BuyToneComponentHandler).onRequestOtpClick();
    }

    onClosePopup(): void {
        (this.getUIProps() as BuyToneComponentProps).closePopup();
    }


    validate(): boolean {
        // if(this.contactNumber.validate())
        // {
        //     let numberMinLength = +this.getUIProps().context.getResources().getString(Strings.numberMinLength);
        //     let numbermaxLength = +this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

        //     if(this.contactNumber.getData().length < numberMinLength 
        //                     || this.contactNumber.getData().length > numbermaxLength)
        //     {
        //         this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
        //         return false;
        //     }

        //     return true;
        // }
        // return false;

        if (this.contactNumber.validate()) {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.contactNumber.getData());

            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);


            if (!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength)) {
                this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;
            }
            // else if(this.getContext().getUserContext().getMsisdn() === this.contactNumber.getData())
            // {
            //     this.contactNumber.setErrorMessage(this.getContext().getResources().getString(Strings.number_cannot_be_same_as_the_logged_in_number));
            //     return false;
            // }


            return true;
        }
        return false;
    }

    getData(): BuyToneDto {
        let toneDto = (this.getUIProps() as BuyToneComponentProps).toneDto;
        let request = new BuyToneDtoImpl();
        request.setToneId((this.getUIProps() as BuyToneComponentProps).toneOptionsType
            === ToneOptionsType.TONE ? toneDto.getId() : toneDto.getContentId().split("|")[0]);
        request.setToneName(toneDto.getToneName());
        request.setLanguage(this.getUIProps().context.getUserContext().getLanguage());
        request.setMsisdn(this.contactNumber.getData());
        request.setUserName(this.getUIProps().context.getUserContext().getUsername());
        request.setChannel(this.getUIProps().context.getUserContext().getChannelId());
        request.setPackName((this.getUIState() as BuyToneComponentState).packName);
        // request.setMsisdn(this.contactNumber.getData());

        return request;
    }
    getOTPData(): SendOTPDto {
        let request = new SendOTPDtoImpl();
        request.setMsisdn((this.getUIState() as BuyToneComponentState).msisdn);

        return request;
    }
    onSelected(ischecked: boolean, title: string) {
        (this.getUIComponentHandler() as BuyToneComponentHandler).onPackSelected(ischecked);
    }

    routeToUpgradePack(): void {


    }
    private onConfirmClick() {
        (this.getUIComponentHandler() as BuyToneComponentHandler).onConfirmClick();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/buytone/buytoneview.tsx